export function matchesServiceRequest(requestUrl?: string, serviceUrl?: string)
{
    if (!requestUrl || !serviceUrl)
        return false;

    const request = requestUrl.replace(/\/+$/u, '');
    const service = serviceUrl.replace(/\/+$/u, '');

    return request === service || request.startsWith(`${service}/`) || request.startsWith(`${service}?`);
}
